import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[newTabNavigation]'
})
export class NewTabNavigationDirective {
  @Input('newTabNavigation') route: string | string[] = [];

  constructor(private router: Router) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (event.metaKey || event.ctrlKey) {
      event.preventDefault();
      // Create full URL for new tab
      const url = this.router.serializeUrl(
        this.router.createUrlTree(Array.isArray(this.route) ? this.route : [this.route])
      );
      window.open(url, '_blank');
    } else {
      this.router.navigate(Array.isArray(this.route) ? this.route : [this.route]);
    }
  }
}